// extracted by mini-css-extract-plugin
var _1 = "Vx8exAZDG1PYZmN8T51r";
var _2 = "N0pVhsXj39h6QxSvPGeQ";
var _3 = "JVBY5Rv26sL64SM0l8Bp";
var _4 = "ywm1A56ySJjRSnWfZ2VQ";
var _5 = "tWwhQi6WiIjo4KK7zyJi";
var _6 = "_ywPTuy7CwKnRmneQo1h";
var _7 = "gIoABIRdVgXBUqrerc5v";
var _8 = "RojE0WEPDkSaTtubWjsA";
var _9 = "R9CBS02zQXi2JNNWkqWL";
var _a = "UelBQn5mFrfif5qrNhI_";
var _b = "SSeuug15yqcmQZbRPY7j";
var _c = "GAeIYRvYgBZngN0x6QzB";
var _d = "_4ekvZqsepxVsId_MaqyG";
var _e = "T8lAi_aw3YlPqCeqMBb_";
var _f = "Ae8KC7mJV9NDWN95ued1";
var _10 = "IjYmCMwEEuNTPrKk19ht";
var _11 = "EO14djkvIWfr25tHagat";
var _12 = "jfmNj02aOUm6F5FM3Zko";
var _13 = "jMuuvZ0J1GwhBn_Tn9XM";
var _14 = "_29Lg9UIExg6Y2buWT5c";
var _15 = "Ntrq2ffzaXuQpXf1F71X";
var _16 = "QSJy5mBy8h5hPY9gOSAu";
var _17 = "VnOxeAEafTwqgyt9UFJG";
var _18 = "mJdEB4ymLi1McSu9gUYu";
var _19 = "K2ilcStskzoON9_jdCgr";
var _1a = "I3YAHG6UiFGYkmIRAdoy";
var _1b = "r2JxvUyd2b8Y9ZrGTADg";
export { _1 as "brivityBlue", _2 as "brivityOrange", _3 as "darkBlue", _4 as "gray", _5 as "grayBase", _6 as "intentBuyer", _7 as "intentCandidate", _8 as "intentLandlord", _9 as "intentNone", _a as "intentRecruit", _b as "intentSeller", _c as "intentSellerBuyer", _d as "intentTenant", _e as "statusActiveClient", _f as "statusArchived", _10 as "statusHot", _11 as "statusInactive", _12 as "statusNew", _13 as "statusNurt", _14 as "statusOther", _15 as "statusPast", _16 as "statusPending", _17 as "statusProspectiveClient", _18 as "statusTrash", _19 as "statusUnqual", _1a as "statusWatch", _1b as "yellowOrange" }
